import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as allocateResources from "./allocateResources";
import * as checkAllocationWarnings from "./checkAllocationWarnings";
import * as editAllocation from "./editAllocation";
import * as removeAllocation from "./removeAllocation";
import * as sendActivityReport from "./sendActivityReport";

const initialState: State = {
  allocateResources: allocateResources.initialState,
  checkAllocationWarnings: checkAllocationWarnings.initialState,
  editAllocation: editAllocation.initialState,
  removeAllocation: removeAllocation.initialState,
  sendActivityReport: sendActivityReport.initialState,
};

const reduceState = combineStateReducer(initialState, {
  allocateResources: allocateResources.reduceState,
  checkAllocationWarnings: checkAllocationWarnings.reduceState,
  editAllocation: editAllocation.reduceState,
  removeAllocation: removeAllocation.reduceState,
  sendActivityReport: sendActivityReport.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...allocateResources.createSelector(() => getState().allocateResources),
    ...checkAllocationWarnings.createSelector(
      () => getState().checkAllocationWarnings,
    ),
    ...editAllocation.createSelector(() => getState().editAllocation),
    ...removeAllocation.createSelector(() => getState().removeAllocation),
    ...sendActivityReport.createSelector(() => getState().sendActivityReport),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
